import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import {singInUser} from '../../actions';
import { TransitionGroup, Transition } from 'react-transition-group';
import anime from 'animejs';
import { Link } from 'react-router-dom'

import {
    Row,
    Container,
    Col,
    Card,
    CardGroup,
    CardBlock,
    Button
} from 'reactstrap';

class Signin extends Component{
    handleRedirect(){
        this.props.push('/result');
    }
    handleFormSubmit({ email, password }){
        console.log(this.props);
        this.props.singInUser({ email, password }, this.handleRedirect);
    }
    renderError(){
        if(this.props.errorMessage) {
            return(
                <div className="alert alert-danger" role="alert">
                    {this.props.errorMessage}
                </div>
            )
        }
    }
    animateIn = (el, isAppearing) => {
        anime({
                targets: el,
                translateX: [-1000, 0],
                opacity: [0, 1],
                duration: 500,
                easing: 'easeInOutSine'
            })
    }
    render(){
        const { handleSubmit, fields: { email, password }} = this.props;
        return(

        <div className="app flex-row align-items-center">
            <Container>
                <Row className="justify-content-center">
                    <Col md="6">
                        <CardGroup>
                            <Card className="p-4">
                                <CardBlock>
                                    <form className="form-signin" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
                                        <h1>Acceso a usuarios</h1>
                                        <p className="text-muted">Introduce tus datos de usuario</p>
                                        {this.renderError()}
                                        <div className="input-group mb-3">
                                            <span className="input-group-addon"><i className="fa fa-user"></i></span>
                                            <Field
                                                className="form-control"
                                                name="email"
                                                component="input"
                                                type="text"
                                                placeholder="Email"
                                            />
                                        </div>
                                        <div className="input-group mb-3">
                                            <span className="input-group-addon"><i className="fa fa-lock"></i></span>
                                            <Field
                                            className="form-control"
                                            name="password"
                                            component="input"
                                            type="password"
                                            placeholder="Contraseña"
                                            />
                                        </div>
                                        <Row>
                                            <Col xs="6">
                                                <Link className="panel-block" to={`/recover`}>
                                                    <a className="btn btn-link px-0">Recuperar contraseña</a>
                                                </Link>

                                            </Col>
                                            <Col xs="6" className="text-right">
                                                <Button block color="primary" type="submit" className="px-4">Login</Button>
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBlock>
                            </Card>
                        </CardGroup>
                    </Col>
                </Row>
            </Container>
        </div>
        )
    }
}

function mapStateToProps(state){
    return { errorMessage: state.auth.error };
}

Signin = reduxForm({
    form: 'signin',
    fields: ['email', 'password']
})(Signin);
export default Signin = connect(mapStateToProps, {singInUser})(Signin);


// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/signin.jsx